export interface ICaseNote {
  id: string;
  caseIdentifier: string;
  timepoint?: string;
  eventTime?: string;
  content: string;
  createdAt: string;
  updatedAt: string;
  creatorNames: string;
  history?: ICaseNoteHistory[];
}

export interface ICaseNoteHistory {
  id: string;
  noteId: string;
  operation: 'INSERT' | 'UPDATE' | 'DELETE' | string;
  caseIdentifier: string;
  timepoint?: string | null;
  eventTime?: string | null;
  content: string;
  creatorIdentifier: string;
  creatorNames: string;
  changedAt: string;
}

export interface ICaseNotesResponse {
  notes: ICaseNote[];
  nmpStartTime?: string | null;
}

export interface PostCaseNote {
  timepoint?: string;
  eventTime?: string;
  content: string;
}

export class CaseNoteModel {
  id: string;
  caseIdentifier: string;
  timepoint?: string;
  eventTime?: Date;
  content: string;
  createdAt: Date;
  updatedAt: Date;
  creatorNames: string;
  history: CaseNoteHistoryModel[];

  constructor(note: ICaseNote) {
    this.id = note.id;
    this.caseIdentifier = note.caseIdentifier;
    this.timepoint = note.timepoint;
    this.eventTime = note.eventTime ? new Date(note.eventTime) : undefined;
    this.content = note.content;
    this.createdAt = new Date(note.createdAt);
    this.updatedAt = new Date(note.updatedAt);
    this.creatorNames = note.creatorNames;
    this.history = (note.history ?? []).map(CaseNoteHistoryModel.mapFromBackend);
  }

  static mapFromBackend(note: ICaseNote): CaseNoteModel {
    return new CaseNoteModel(note);
  }
}

export class CaseNoteHistoryModel {
  id: string;
  noteId: string;
  operation: string;
  caseIdentifier: string;
  timepoint?: string;
  eventTime?: Date;
  content: string;
  creatorIdentifier: string;
  creatorNames: string;
  changedAt: Date;

  constructor(history: ICaseNoteHistory) {
    this.id = history.id;
    this.noteId = history.noteId;
    this.operation = history.operation;
    this.caseIdentifier = history.caseIdentifier;
    this.timepoint = history.timepoint ?? undefined;
    this.eventTime = history.eventTime ? new Date(history.eventTime) : undefined;
    this.content = history.content;
    this.creatorIdentifier = history.creatorIdentifier;
    this.creatorNames = history.creatorNames;
    this.changedAt = new Date(history.changedAt);
  }

  static mapFromBackend(history: ICaseNoteHistory): CaseNoteHistoryModel {
    return new CaseNoteHistoryModel(history);
  }
}

export interface TimepointOption {
  label: string;
  value: string;
}
